
import { defineComponent } from "vue";

export default defineComponent({
    name: "SideMenu",
    props: {
        menuData: Array,
    },
    emits:['selectMenu'],
    data() {
        return {};
    },
    mounted() {
        // console.log("this.menuData", this.menuData);
    },
    methods: {

    },
});
